// extracted by mini-css-extract-plugin
export default {"page":"Attendances_page__itiXi","container":"Attendances_container__zSn-6","header":"Attendances_header__eEBRO","bar":"Attendances_bar__1WGLE","table":"Attendances_table__F-auV"};